/**
 * Created by Viacheslav Stepanian on 03.07.2026
 */

const HungryGamesCustomerView = function (hungryGamesCustomer, unitView) {
    this.hungryGamesCustomer = hungryGamesCustomer;
    this.unitView = unitView;

    this.restoreState();
};

HungryGamesCustomerView.prototype.restoreState = function () {
    this.restoreProgress();
};

HungryGamesCustomerView.prototype.restoreProgress = function () {
    if (this.progress) {
        this.progress.removeFromParent();
        this.progress = undefined;
    }

    const mission = HungryGamesCustomer.getMission();
    if (!mission) {
        return;
    }

    const styles = cleverapps.styles.HungryGamesCustomerView.progress;

    const progress = this.progress = new ScaledProgressBar({
        type: ScaledProgressBar.Types.blue,
        barText: {}
    });
    progress.setLength(styles.width);
    progress.setGoal(HungryGamesLogic.LEVELS_AMOUNT);
    progress.setPercentage(mission.result);
    progress.setAlignment(styles);

    const badge = new cc.Sprite(bundles.reward_icons.frames.hungry_games_level_bg || bundles.merge.frames.upgradable_level_png);
    badge.setLocalZOrder(1);
    badge.setAlignment(styles.badge);
    progress.addChild(badge);

    const icon = new cleverapps.Spine(bundles.reward_icons.jsons.hungry_games_icon);
    icon.setAnimation(0, "animation", true);
    cleverapps.UI.fitToBox(icon, styles.badge.icon);
    icon.setAlignment(badge.width / 2, badge.height / 2);
    badge.addChild(icon);

    cleverapps.UI.onClick(progress, () => {
        cleverapps.focusManager.display({
            focus: "HungryGamesWindow",
            action: function (f) {
                new HungryGamesWindow(mission);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }, { swallowEvents: true });

    this.unitView.addChild(progress);
};

cleverapps.styles.HungryGamesCustomerView = {
    progress: {
        width: 180,

        x: { align: "center" },
        y: { align: "bottom", dy: 26 },

        badge: {
            x: { align: "left", dx: -30 },
            y: { align: "center" },

            icon: {
                width: 44,
                height: 44
            }
        }
    }
};
